import Intercom, { hide, shutdown, update } from '@intercom/messenger-js-sdk';
import { User } from 'generated/graphql';

// Workspace is on EU data hosting (api-iam.eu.intercom.io).
const INTERCOM_REGION = 'eu';

let isBooted = false;

/**
 * Boots the messenger on the first call of a session and, on every later
 * call, only moves the launcher in or out of view. Hiding goes through
 * `hide_default_launcher` rather than a shutdown: a shutdown drops the
 * session and re-runs the whole boot, which Intercom rate-limits in
 * single-page apps.
 */
export const syncIntercom = (user: User, launcherHidden: boolean) => {
  if (!isBooted) {
    isBooted = true;
    Intercom({
      app_id: import.meta.env.VITE_INTERCOM_APP_ID,
      region: INTERCOM_REGION,
      email: user.email || '',
      hide_default_launcher: launcherHidden,
    });
    return;
  }
  if (launcherHidden) {
    hide();
  }
  update({ hide_default_launcher: launcherHidden });
};

// Clears the visitor's conversation cookie so the next user on the same
// browser cannot read their support chats. The next `syncIntercom` boots anew.
export const shutdownIntercom = () => {
  isBooted = false;
  if (window.Intercom) {
    shutdown();
  }
};
